//* 법정 문구에 준하는 대가성 고지 — 한 글자도 바꾸지 않는다.
export const AFFILIATE_DISCLOSURE =
  '이 링크를 통해 구매가 발생한 경우 웰로는 일정액의 수수료를 제공받습니다.';

export const CHANNEL_LABEL = {
  ALL: null,
  WEB_ONLY: '웹사이트 전용',
  APP_ONLY: '앱 전용',
} as const;

export const MERCHANT_SECTION_LABEL = {
  LARGE_SHOPPING: '종합 제휴몰',
  TRAVEL_STAY: '여행 숙소',
  ETC: '기타',
} as const;

export const MERCHANT_TAB = {
  BRAND: 'brand',
  PRODUCT: 'product',
} as const;

export type MerchantTab = (typeof MERCHANT_TAB)[keyof typeof MERCHANT_TAB];

export const MERCHANT_PRODUCT_PAGE_SIZE = 20;
